'use client';
import React, { useEffect } from 'react';

import { IChinaPageHome } from '@/lib/fragments/chinaPageHome';
import { ILibraryMenuGroup } from '@/lib/fragments/libraryMenuGroup';
import { ChinaHeader } from '../china-header/china-header';
import { ITextAndImageCardBlock } from '../../../lib/fragments/textAndImageCardBlock';
import Footer from '../china-footer/china-footer';
import applyGoogleTranslateDOMPatch from '@/helpers/applyGoogleTranslateDOMPatch';

type ChinaLayoutProps = {
  contentfulMeetingPlacePageHome: {
    meetingPlace?: IChinaPageHome;
    menuItem: ILibraryMenuGroup[];
    menuCards: ITextAndImageCardBlock[];
  };
};

export const ChinaLayout = ({ children, layoutData, footerData }: any) => {
  useEffect(() => {
    applyGoogleTranslateDOMPatch();
  }, []);

  return (
    <>
      <div className="relative lg:container">
        {layoutData?.meetingPlacePageHome && (
          <ChinaHeader
            menuCards={
              layoutData?.meetingPlacePageHome.menuCardsCollection?.items
            }
            menuItems={
              layoutData?.meetingPlacePageHome.menuItemCollection?.items
            }
            meetingPlace={layoutData?.meetingPlacePageHome?.meetingPlace}
          />
        )}
        {children}
      </div>
      <div>
        <Footer data={footerData} />
      </div>
    </>
  );
};

export default ChinaLayout;
